import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { RestAPIService } from 'src/app/services/restapi.service';
import { environment } from 'src/environments/environment';
import { VideoModel } from '../../models/VideoModel';
import { ToastService } from 'src/app/services/toaster.service';
import { FormControl, Validators } from '@angular/forms';
import { VideoCategoryEnum } from 'src/app/enums/videoCategoryEnum';
import { VideoTypeEnum } from 'src/app/enums/videoTypeEnum';
import { StationListModel } from 'src/app/modules/station/models/stationListModel';
import { ConfirmDialogComponent } from 'src/app/components/confirmation/confirm-dialog.component';
import { map, Observable, startWith } from 'rxjs';

@Component({
  selector: 'app-video-add-edit',
  templateUrl: './video-add-edit.component.html',
  styleUrl: './video-add-edit.component.css'
})
export class VideoAddEditComponent {
    submitted: boolean = false;
    video: VideoModel = new VideoModel();
    stationList: StationListModel[] = [];
    category = new FormControl('', [Validators.required]);
    autoPurge = new FormControl(null, [Validators.required]);
    codeDescription = new FormControl(null, [Validators.required]);
    station = new FormControl<StationListModel | string | null>('');
    filteredStation!: Observable<StationListModel[]>;
    videoType = new FormControl('');
    videoCode = new FormControl('');
    via = new FormControl('');
    videoCategoryEnum = Object.values(VideoCategoryEnum);
    videoCategorys = VideoCategoryEnum;
    videoTypeEnum = Object.values(VideoTypeEnum);
    isFileDownload = false;
    
    constructor(public _restAPI: RestAPIService, public dialog: MatDialog, private toast: ToastService, public dialogRef: MatDialogRef<VideoAddEditComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {
        this._restAPI.loading  = false;
        this.video = JSON.parse(JSON.stringify(data.videoModel));
        this.stationList = JSON.parse(JSON.stringify(data.stationList));
        localStorage["applyVideoFilterValue"] = 'true';
        this.stationList = this.stationList.sort((a, b) => a.name!.localeCompare(b.name!));
        this.filteredStation = this.station.valueChanges.pipe(
            startWith(''),
            map(value => typeof value === 'string' ? value : 'value?.name'),
            map(name => name ? this._filterStation(name) : this.stationList.slice())
        );
        if(!this.video.category){
            this.video.category = this.videoCategorys.StationSpecific;
            this.video.autoPurge = 192;
        }
        if(this.video.id){
            this.isFileDownload = true;
            this.station.setValue(this.stationList.filter(x=>x.id==this.video.stationId)[0]);
        }
        this.categoryChange();
    }

    displayStation(station: StationListModel): string {
        return station && station.name ? station.crsCode + ' - ' + station.name : '';
    }

    private _filterStation(name: string): StationListModel[] {
        if (name) {
            name = name.includes(' - ') ? name.slice(name.indexOf(' - ')) : name;
            name = name.replace(' - ','');
        }
        const filterValue = name.toLowerCase();
        return this.stationList.filter(station => station.name!.toLowerCase().includes(filterValue) || station.crsCode!.toLowerCase().includes(filterValue));
    }

    categoryChange(){
        this.station?.clearValidators();
        this.videoType?.clearValidators();
        this.videoCode?.clearValidators();
        this.codeDescription?.clearValidators();

        
        if(this.video.category === this.videoCategorys.StationSpecific){
            this.station?.addValidators(Validators.required);
            this.videoType?.addValidators(Validators.required);
        }
        else {
            this.videoCode?.addValidators(Validators.required);
            this.codeDescription?.addValidators(Validators.required);
        }
        this.station.updateValueAndValidity();
        this.videoType.updateValueAndValidity();
        this.videoCode.updateValueAndValidity();
        this.codeDescription.updateValueAndValidity();
    }

    closeDialog(): void {
        this.dialogRef.close(false);
    }
  
    saveVideo() {
        if(!this.category.invalid && !this.autoPurge.invalid && !this.station.invalid && !this.videoType.invalid && !this.videoCode.invalid && !this.codeDescription.invalid){
            this._restAPI.loading  = true;
            let formData = new FormData();
            formData.append('category', this.video.category!);
            formData.append('autoPurge', this.video.autoPurge?.toString()!);
            if(this.video.category === this.videoCategorys.StationSpecific) {
                this.video.stationId = this.getStationId();
                if(!this.video.stationId){
                    this._restAPI.loading = false;
                    this.toast.error('Please select valid station');
                    return;
                }
                formData.append('stationId', this.video.stationId!);
                formData.append('type', this.video.type!);
                formData.append('code', '');
                formData.append('codeDescription', '');
                formData.append('via', this.video.via!);
            }
            else {
                formData.append('stationId', '');
                formData.append('type', '');
                formData.append('code', this.video.code!);
                formData.append('codeDescription', this.video.codeDescription!);
                formData.append('via', '');
            }
            if (this.video.id != null && this.video.id.length > 0) {
                if(!this.video.fileName){
                    this._restAPI.loading  = false;
                    this.toast.error('Please select video file');
                    return;
                }
                if(this.selectedFile){
                    formData.append('video', this.selectedFile);
                }
                this._restAPI.putFormData<string>(environment.apiURL + 'api/video/edit/' + this.video.id, formData).subscribe({
                    next: (results) => {
                        this._restAPI.loading  = false;
                        this.dialogRef.close(true);
                        this.toast.show("Video has been updated successfully");
                    },
                    error: (error) => {this._restAPI.loading  = false;this.toast.error(error)}
                });
            }
            else {
                if(!this.selectedFile){
                    this._restAPI.loading  = false;
                    this.toast.error('Please select video file');
                    return;
                }
                formData.append('video', this.selectedFile);
                this._restAPI.postFormData<string>(environment.apiURL + 'api/video/add', formData).subscribe({
                    next: (results) => {
                        this._restAPI.loading  = false;
                        this.dialogRef.close(true);
                        this.toast.show("Video has been added successfully");
                    },
                    error: (error) => {this._restAPI.loading  = false;this.toast.error(error)}
                });
            }
        }
    }
    
    private getStationId () {
        if (typeof this.station.value === 'object' && this.station.value){
            return this.station.value.id;
        }
        else {
            return undefined;
        }
    }

    // drage and drop 
    selectedFile: File | null = null;
    selectedFileName: string | null = null;
    isDragOver = false;
    

    onDragOver(event: DragEvent) {
        event.preventDefault();
        this.isDragOver = true;
    }

    onDragLeave(event: DragEvent) {
        event.preventDefault();
        this.isDragOver = false;
    }

    onDrop(event: DragEvent) {
        event.preventDefault();
        this.isDragOver = false;

        if (event.dataTransfer?.files) {
            if (!event.dataTransfer.files?.length) return;
            const file = event.dataTransfer.files[0];
            this.addFile(file);
        }
    }

    onFileSelected(event: Event) {
        const target = event.target as HTMLInputElement;
        if (!target.files?.length) return;
        const file = target.files[0];
        this.addFile(file);
    }

    addFile(file: File) {
        const validTypes = ['video/mp4'];
        if (!validTypes.includes(file.type)){
            this.toast.error("Invalid Format");
            return;
        }
        const sizeInMB = file.size / (1024 * 1024);
        if (sizeInMB > 100){
            this.toast.error('Video file size exceeds 100 MB limit.');
            return;
        }
        if(this.selectedFile)
            this.toast.show("Video file changes to " + file.name);
        this.isFileDownload = false;
        this.selectedFile = file;
        this.video.fileName = file.name;
    }
    removeFile() {
        const dialogRef = this.dialog.open(ConfirmDialogComponent, {
            width: '500px',
            data: {
                message: `Are you sure you want to remove this Video file?`
            }
            });
        
            dialogRef.afterClosed().subscribe(result => {
            if (result === true) {
                this.isFileDownload = false;
                this.selectedFile = null;
                this.video.fileName = undefined;
            }
            else{
                
            }
        });
        
    }

    downloadFile() {
        this._restAPI.loading  = true;
        this._restAPI.getFile(environment.apiURL + 'api/video/download/' + this.video.id).subscribe({
            next: (response) => {
                this._restAPI.loading  = false;
                const blob = response.body!;
                const filename = this.video.fileName;
                const a = document.createElement('a');
                const objectUrl = URL.createObjectURL(blob);
                a.href = objectUrl;
                a.download = filename!;
                // a.download = filename;
                a.click();
                URL.revokeObjectURL(objectUrl);
            },
            error: (error) => {this._restAPI.loading  = false;this.toast.error(error)}
        });
    }
}